import axios from 'axios';

import { ACCESS_TOKEN } from './AuthService';

export const getHeaders = () => {
  const token = localStorage.getItem(ACCESS_TOKEN);
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};


export const fetchMessage = async (): Promise<string> => {
  try {
    const response = await axios.get(`/api/hello`, { headers: getHeaders() });
    return response.data;
  } catch (err: any) {
    console.error(err);
    throw err;
  }
};

export const getAllVocabulary = async (): Promise<any> => {
  try {
    const response = await axios.get(`/api/getAllVocabulary`, { headers: getHeaders() });
    console.log("API Response data:", response.data);
    console.log("API Response data type:", typeof response.data);
    
    // Axios automatically parses JSON, so return the parsed object
    return response.data;
  } catch (err: any) {
    console.error(err);
    throw err;
  }
};

export const askOpenAI = async (question: string): Promise<string> => {
  try {
    const requestBody : any = {
      question: question,
    };
    const response = await axios.post(`/api/ask`, requestBody, { headers: getHeaders() });
    return response.data;
  } catch (err: any) {
    console.error('OpenAI API error:', err);
    throw err;
  }
};

export const sendOpenAI = async (request: any): Promise<string> => {
  try {
    // Ensure proper JSON serialization to handle newlines and special characters
    const response = await axios.post(`/api/send`, request, { 
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json'
      }
    });

    return response.data;
  } catch (err: any) {
    console.error('OpenAI API error:', err);
    throw err;
  }
};

export const getNextSentences = async (request: any): Promise<any> => {
  try {
    // Ensure proper JSON serialization to handle newlines and special characters
    const response = await axios.post(`/api/getNextSentences`, request, {
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json'
      }
    });

    return response.data;
  } catch (err: any) {
    console.error('OpenAI API error:', err);
    throw err;
  }
};

export const handleSpeak = async (text: string) => {
  try {
    const response = await axios.post('/api/tts', 
      { content: "..." + text.toUpperCase() + "..." }, 
      { headers: getHeaders(), responseType: 'blob' })
      ;

    const blob = new Blob([response.data], { type: 'audio/mpeg' });
    const url = URL.createObjectURL(blob);
    const audio = new Audio(url);

    
    audio.play();
  } catch (error) {
    console.error('Error calling TTS API:', error);
    throw error;
  }
};

export const addWordToVocabulary = async (word: string): Promise<string> => {
  try {
    const requestBody : any = {
      word: word,
    };
    const response = await axios.post(`/api/addWordToVocabulary`, requestBody, { headers: getHeaders() });
    return response.data;
  } catch (err: any) {
    console.error('Add word API error:', err);
    throw err;
  }
};

export const deleteWord = async (id: number): Promise<string> => {
    const requestBody = {
        index: id
    };
    const response = await axios.post(`/api/deleteWord`, requestBody, { headers: getHeaders() });
    return response.data;
};

export const getWordExplanation = async (word: string): Promise<string> => {
  try {
    const requestBody = {
      word: word,
    };
    const response = await axios.post(`/api/getWordExplanation`, requestBody, { headers: getHeaders() });
    return response.data;
  } catch (err: any) {
    console.error('Get word explanation API error:', err);
    throw err;
  }
};

export const transcribeAudio = async (blob: Blob): Promise<string> => {
  try {
    const formData = new FormData();
    formData.append('file', blob, 'recording.webm');
    const token = localStorage.getItem(ACCESS_TOKEN);
    const response = await axios.post(`/api/transcribe`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (err: any) {
    console.error('Transcribe API error:', err);
    throw err;
  }
};